import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-verify-reset-password',
    standalone: false,
    templateUrl: './verify-reset-password.component.html',
    styleUrl: './verify-reset-password.component.scss',
})
export class VerifyResetPasswordComponent {
    protected email = this.activatedRoute.snapshot.queryParamMap.get('email') || '';

    constructor(private activatedRoute: ActivatedRoute) {}
}
